import { createContext, useState, useEffect } from 'react'

export const RondaContext = createContext()

export const RondaProvider = ({ children }) => {
    const [respostaLog, setRespostaLog] = useState()

    useEffect(() => {
    }, [respostaLog])

    return (
        <RondaContext.Provider value={{ respostaLog, setRespostaLog }}>
            {children}
        </RondaContext.Provider>
    )
}
